












































































import {Component, Prop} from 'vue-property-decorator';
import {Getter} from "vuex-class";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import PriorityRulesFilter from "@/components/Rules/PriorityRules/PriorityRulesFilter.vue";
import {ScrollButton} from "wings-ui-components";
import {PriorityRuleItem} from "@/store/rules/priority_rules/types";
import {MsgTransports} from "@/store/types";

@Component({components:{PriorityRulesFilter, ScrollButton}})
export default class PriorityRules extends BaseItemsPage<PriorityRuleItem> {
  @Prop() transport!: MsgTransports;
  @Getter("priorityRules") priorityRulesResponse: any;
  private is_show_filter = false;
  currentSort= "id";
  currentSortOrder= "desc";
  tableFields = [
    'partner',
    'originator',
    'template',
    'priority',
  ];

  getData(): any {
    return this.priorityRulesResponse;
  }
}
